<template>
  <div class="table-meta">
    <div class="table-count">
      <div>{{ getTotalItemsText() }}</div>
    </div>

    <div class="table-pagination" v-if="meta.totalItems > 0">
      <button class="button is-inline-block" :disabled="$store.state[this.dataType].all.currentPage === 1 || loading" @click="pageBack">
        <i class="fal fa-angle-left"></i>
      </button>
      <span class="table-pagination-info page-info">Sida {{ $store.state[this.dataType].all.currentPage }} / {{ meta.totalPages }}</span>
      <button class="button is-inline-block" :disabled="$store.state[this.dataType].all.currentPage === meta.totalPages || loading" @click="pageForward">
        <i class="fal fa-angle-right"></i>
      </button>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  props: {
    meta: Object,
    loading: Boolean,
    dataType: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('users', ['getListData', 'delete']),

    getTotalItemsText () {
      if (this.meta.totalItems === undefined) {
        return null
      }
      if (this.meta.totalItems === 0) {
        return 'Inga träffar'
      }
      if (this.meta.totalItems === 1) {
        return '1 träff'
      }
      return this.meta.totalItems + ' träffar'
    },

    pageBack () {
      if (this.$store.state[this.dataType].all.currentPage > 1) {
        this.$store.state[this.dataType].all.currentPage--
        this.$store.dispatch(this.dataType + '/getListData')
      }
    },

    pageForward () {
      if (this.$store.state[this.dataType].all.currentPage < this.meta.totalPages) {
        this.$store.state[this.dataType].all.currentPage++
        this.$store.dispatch(this.dataType + '/getListData')
      }
    },

    closeModal () {
      this.$emit('closeModal')
    }
  },
  created () {
  }
}
</script>

<style scoped>
  .page-info {
    display: inline-block;
    width: 100px;
    line-height: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/AgileTablePagination.vue